export function request(query) {
    return {
        type: 'EVENTS_SEARCH_REQUEST',
        query
    };
}

export function error(errors) {
    return {
        type: 'EVENTS_SEARCH_ERROR',
        errors
    };
}

export function finish(events) {
    return {
        type: 'EVENTS_SEARCH_FINISH',
        events
    };
}
